Postlogin = ((self) => {
    self.LessonAssignments = {};
    const me = self.LessonAssignments;
    me.$assignmentsListTable = $('#assignments-list-table');

    me.initAssignmentsTable = () => {
        $('#export').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const opts = me.$assignmentsListTable.bootstrapTable('getOptions');

            const exportParams = {
                columns: _.map(me.$assignmentsListTable.bootstrapTable('getVisibleColumns'), (col) => [col.title, col.field]),
                sort: opts.sortName,
                order: opts.sortOrder,
                search: opts.searchText,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            };
            window.open(`${href}?${$.param(exportParams)}`, '_blank');
        });

        me.$assignmentsListTable.bootstrapTable({
            formatNoMatches() {
                return 'No lesson assignments to show';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            sidePagination: 'server',
            url: me.userId === me.currentUserId ? '/my-profile/lesson-assignments/json/' : `/users/${me.userId}/lesson-assignments/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search = params.searchText;
                myParams.page = params.pageNumber;
                myParams.pageSize = params.pageSize;
                myParams.sort = params.sortName;
                myParams.order = params.sortOrder;

                return myParams;
            },
            columns: [
                {
                    checkbox: true,
                    checkboxEnabled: true,
                    field: 'checkbox',
                    visible: false,
                },
                {
                    title: 'Assigned',
                    field: 'date_assigned',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Cluster',
                    field: 'cluster',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Grades',
                    field: 'grade_band',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Completion Type',
                    field: 'completion_type',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assigned To',
                    field: 'number_assigned_to',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '% Completed',
                    field: 'percentage_completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    // sr-only title: the column is visually just a
                    // row-action icon set, but screen readers and
                    // axe's empty-table-header rule require a real
                    // accessible header text.
                    title: '<span class="sr-only">Actions</span>',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                me.$assignmentsListTable.closest('.light-blur').removeClass('light-blur');
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $('#number_of_assignments').html(res.meta.total);

                $(formattedResult.rows).each((i, row) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'l';
                    const timeAgoArray = [];
                    const rowData = Jr.Utils.convertRowDate(row, dateFormat, timeAgoArray);

                    rowData.percentage_complete = rowData.percentage_completed;

                    rowData.percentage_completed = `${Math.round(rowData.percentage_completed * 100) / 100}%`;

                    const viewUrl = me.$assignmentsListTable.attr('data-view-url');
                    const assignmentViewUrl = viewUrl
                        .replace(':lesson_id', rowData.lesson_id)
                        .replace(':assignment_id', rowData.assignment_id);

                    const studentsAssignedTo = rowData.number_assigned_to;
                    rowData.number_assigned_to += ' student';
                    if (parseInt(studentsAssignedTo, 10) !== 1) {
                        rowData.number_assigned_to += 's';
                    }
                    rowData.number_assigned_to = `<a href="${assignmentViewUrl}" class="btn btn-hollow-dark-gray">${rowData.number_assigned_to}</a>`;

                    // if lesson has a subtitle, append it under the Cluster
                    if (rowData.subtitle) {
                        rowData.cluster += `<br><em>${rowData.subtitle}</em>`;
                    }

                    rowData.actions = `<a href="${assignmentViewUrl}" class="btn btn-hollow-green">View</a>`;

                    if (+rowData.can_manage === 1) {
                        const assignmentEditUrl = row.locked === '1'
                            ? '#'
                            : me.$assignmentsListTable
                                .attr('data-edit-url')
                                .replace(':lesson_id', rowData.lesson_id)
                                .replace(':assignment_id', rowData.assignment_id);

                        const assignmentDeleteUrl = me.$assignmentsListTable
                            .attr('data-delete-url')
                            .replace(':lesson_id', rowData.lesson_id)
                            .replace(':assignment_id', rowData.assignment_id);

                        const lockedButtonAttributes = row.locked === '1'
                            ? 'disabled title="This assignment cannot be edited because it is being managed automatically."'
                            : '';

                        rowData.actions += `
                            <a href="${assignmentEditUrl}" class="btn btn-hollow-blue" ${lockedButtonAttributes}>Edit</a>
                            <form action="${assignmentDeleteUrl}" method="post" class="delete-entry">
                                <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                <input type="hidden" name="_METHOD" value="DELETE"/>
                                <button type="submit" class="btn btn-hollow-pink" ${lockedButtonAttributes}>Delete</button>
                            </form>
                        `;
                    }
                });

                return formattedResult;
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            rowStyle(row) {
                let classes = '';

                if (row.percentage_complete < 33.3333) {
                    classes += 'danger ';
                } else if (row.percentage_complete < 66.6666) {
                    classes += 'warning ';
                } else if (row.percentage_complete < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
            onCheck() {
                $('#bulk-delete-action-btn').attr('disabled', false);
            },
            onCheckAll() {
                $('#bulk-delete-action-btn').attr('disabled', false);
            },
            onUncheck() {
                if (me.$assignmentsListTable.bootstrapTable('getSelections').length > 0) {
                    $('#bulk-delete-action-btn').attr('disabled', false);
                } else {
                    $('#bulk-delete-action-btn').attr('disabled', true);
                }
            },
            onUncheckAll() {
                $('#bulk-delete-action-btn').attr('disabled', true);
            },
        });
    };

    const startBulkArchiveMode = () => {
        me.$assignmentsListTable.bootstrapTable('showColumn', 'checkbox');
        $('#bulk-delete-btn').text('Cancel Bulk Archive');
        $('#bulk-delete-action-btn').removeClass('hidden');
    };

    const cancelBulkArchiveMode = () => {
        me.$assignmentsListTable.bootstrapTable('hideColumn', 'checkbox');
        $('#bulk-delete-btn').text('Bulk Delete Mode');
        $('#bulk-delete-action-btn').addClass('hidden');
    };

    const handleBulkArchiveAction = () => {
        const selections = me.$assignmentsListTable.bootstrapTable('getSelections');

        if (selections.length > 0) {
            const assignments = JSON.stringify(selections.map((i) => ({ assignment_id: i.assignment_id, lesson_id: i.lesson_id })));
            const url = `/users/${me.currentUserId}/lesson-assignments/bulk-delete/`;
            $.post(url, { assignments }, (data) => {
                const notificationParams = {
                    text: data.data.message,
                    time: 3000,
                    type: data.status,
                };

                VjsUtility.Notification.init(notificationParams);
                $('#bulk-delete-action-btn').attr('disabled', true);
                me.$assignmentsListTable.bootstrapTable('refresh');
            });
        }
    };

    me.init = () => {
        me.userId = me.$assignmentsListTable.attr('data-user-id');
        me.currentUserId = me.$assignmentsListTable.attr('data-current-user-id');
        me.initAssignmentsTable();
        $('#bulk-delete-btn').on('click', () => {
            if (me.$assignmentsListTable.bootstrapTable('getHiddenColumns').length === 0) {
                cancelBulkArchiveMode();
            } else {
                startBulkArchiveMode();
            }
        });
        $('#bulk-delete-action-btn').on('click', () => {
            handleBulkArchiveAction();
        });
    };

    return self;
})(Postlogin || {});
